import { useTranslation } from "@redotech/redo-i18n";
import type { ExchangeCountState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { memo } from "react";

export const ExchangeCountDetails = memo(function ExchangeCountDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<ExchangeCountState>) {
  const { t } = useTranslation();
  return (
    <RedoTextInput
      description={t(
        "Counts how many times the item being returned was previously exchanged. To target items that came from an exchange, set this to 1 — the True path is items NOT from an exchange, and the False path is items that ARE. Every item on an order shares the same count.",
      )}
      inputTypeHint="number"
      label={t("Previous exchanges less than")}
      min={1}
      onBlur={() => setState((+state).toFixed(0))}
      setValue={(e) => setState(e)}
      size="sm"
      state={disabled ? "disabled" : "default"}
      value={state}
    />
  );
});
